/**
 * Presentation helpers shared by the list and grid package cards so both views
 * format identical data the same way.
 */

/**
 * Max characters of the package description rendered on a card. Shared by both
 * the list and grid cards so every card shows the same, full blurb — the client
 * wants the grid card's description to match the list card's.
 */
export const PACKAGE_DESCRIPTION_MAX = 350;

/** Render a `8 Days / 6 Nights` badge. Returns empty when nothing to show. */
export function formatDuration(days: number, nights: number): string {
  if (!days && !nights) return "";
  if (days && nights) return `${days} Days / ${nights} Nights`;
  if (days) return `${days} Days`;
  return `${nights} Nights`;
}
